// 模組05 資產管理 — mock 種子資料（機櫃 / 硬體）
// 機櫃「機櫃資訊」tab 欄位對準 Figma DCK-05_資產管理(115:28676):
//   機房名稱(roomId 帶入鎖定)、業務類別、資產類別、廠牌、型號(→帶出總U數)、機櫃編號(code)、
//   電源迴路、電壓、容量KVA、總U數(鎖定)、左/右電源數、PDU數(左右加總)、上架日期。
//   管理者不存在這裡 —— 它是「人 × 資產」的負責關係(ticket 31/35),見 db/workItems.js。

// 廠牌→型號→總U數 型錄:選型號自動帶出總U數(Figma cascade)
export const cabinetCatalog = {
  APC: [{ model: "AR3100", uTotal: 42 }, { model: "AR3200", uTotal: 45 }],
  Vertiv: [{ model: "VR3100", uTotal: 42 }, { model: "VR3350", uTotal: 48 }],
  Rittal: [{ model: "TS-IT-42U", uTotal: 42 }, { model: "TS-IT-47U", uTotal: 47 }],
};
// 資產類別／業務類別選項改走單一來源(ticket 06),不在這裡各自寫死 — 見 helpers/assetOptions.js

export const cabinets = [
  {
    id: 1,
    code: "R-A01",
    name: "A01 機櫃",
    roomId: 1,
    // 260804 機櫃表單新增的位置/資產欄位:樓層/區域(掛在機房的 floors[].areas[])、
    // 關鍵業務、資產編號/財產編號、購買金額(NT$)
    floorId: 1,
    areaId: 11,
    keyBiz: "不啟用",
    assetCode: "AST-2026-0001",
    propertyNo: "PRP-2026-0001",
    purchaseAmount: 200000,
    bizType: "一類業務",
    assetType: "機房相關",
    brand: "APC",
    model: "AR3100",
    powerCircuit: "PC-01",
    voltage: "220V",
    capacityKva: "5",
    uTotal: 42,
    // uUsed 不再是種子欄位(ticket 28):已用U 由 hardware 上架佔用推導(見 Assets/uSlots.js usedUOf)
    powerCount: 4,
    leftPower: 2,
    rightPower: 2,
    pduCount: 4,
    pduUsed: 3,
    mountDate: "2026-03-01",
    amortEndDate: "2028-01-05", // 結束攤提日(WF_v3 票 21 新欄位)
    docNo: "CAB-2026-0001",
    colorTag: "green",
    locked: false,
    status: "啟用中",
    approvalStatus: "approved",
    // 編輯頁的異動歷程(2128:26326)
    changeLog: [
      {
        at: "2026/07/08 14:32", by: "陳雅婷（EMP0113）", action: "新增",
        detail: "建立機櫃 R-A01（APC / AR3100・42U・PDU 4）",
        docNo: "RQ-20260708-004", result: "已核准（結案）",
      },
      {
        at: "2026/07/10 16:40", by: "張家豪（EMP0201）", action: "異動",
        detail: "管理者：陳雅婷（EMP0113） → 林承翰（EMP0145）",
        docNo: "RQ-20260710-006", result: "審核中（第 2 關）",
      },
    ],
  },
  {
    id: 2,
    code: "R-A02",
    name: "A02 機櫃",
    roomId: 1,
    floorId: 1,
    areaId: 12,
    keyBiz: "不啟用",
    assetCode: "AST-2026-0002",
    propertyNo: "",
    purchaseAmount: 180000,
    bizType: "一類業務",
    assetType: "機房相關",
    brand: "APC",
    model: "AR3200",
    powerCircuit: "PC-02",
    voltage: "220V",
    capacityKva: "5",
    uTotal: 45,
    powerCount: 4,
    leftPower: 2,
    rightPower: 2,
    pduCount: 4,
    pduUsed: 3,
    mountDate: "2026-03-05",
    amortEndDate: "2028-03-05",
    docNo: "CAB-2026-0002",
    colorTag: "gray",
    locked: false,
    status: "閒置",
    approvalStatus: "approved",
    changeLog: [],
  },
  {
    // WF_v3 票 21:維修中＋替代機(列表狀態欄「維修中｜替代機 APC / AR3100」)
    id: 3,
    code: "R-B01",
    name: "B01 機櫃",
    // 掛在桃園青埔(room 3):新莊(room 2)在 dcRoomsApi 測試裡是「無機櫃可刪」的樣本
    roomId: 3,
    floorId: 4,
    areaId: 41,
    keyBiz: "不啟用",
    assetCode: "AST-2026-0003",
    propertyNo: "",
    purchaseAmount: 200000,
    bizType: "二類業務",
    assetType: "機房相關",
    brand: "APC",
    model: "AR3100",
    powerCircuit: "PC-03",
    voltage: "220V",
    capacityKva: "5",
    uTotal: 42,
    powerCount: 4,
    leftPower: 2,
    rightPower: 2,
    pduCount: 4,
    pduUsed: 1,
    mountDate: "2026-04-10",
    amortEndDate: "2028-04-10",
    docNo: "CAB-2026-0003",
    colorTag: "gray",
    locked: false,
    status: "維修中",
    spareBrand: "APC",
    spareModel: "AR3100",
    approvalStatus: "approved",
    changeLog: [],
  },
  // 2026-10-20 SIT 樣本（DcRack/GetById/136 原樣，個資已換假）
  // SIT 的 room_id 5／floor_id 7／area_id 29 換成 mock 裡同為 SIT 樣本的「分行據點機房」(room 4／1F floor 5／A區 area 27)。
  // 業務／資產類別、資產編號、廠牌型號、電源迴路、幣別、說明在 SIT 都是 null(id 0),照抄;沒有管理者(0／null)。
  // 本筆沒有個資欄位,不需換假。
  {
    id: 4,
    code: "1A01",
    name: "NO-1A01-RACK",
    roomId: 4,
    floorId: 5,
    areaId: 27,
    keyBiz: "不啟用",
    bizType: null,
    assetType: null,
    assetCode: null,
    brand: null,
    brandId: 0,
    model: null,
    modelId: 0,
    powerCircuit: null,
    voltage: "220V",
    capacityKva: 0,
    pduCount: 0,
    pduUsed: 0,
    leftPower: 0,
    rightPower: 0,
    uTotal: 42,
    mountDate: "2026-09-01T00:00:00",
    purchaseAmount: 0,
    currency: null,
    description: null,
    status: "啟用中",
    approvalStatus: "approved",
    createdOn: "2026-09-29T10:17:02.014466+08:00",
    updatedOn: "2026-09-29T10:17:02.014469+08:00",
    changeLog: [],
  },
];

// 硬體種子 = **後端 DTO 形狀**(swagger DcHardwareDto ∪ DcHardwareListItemDto 的存得住的鍵;票 poc-20260922/07)。
//   後端算得出來的不存(機房／機櫃編號、EOS／EOL 風險等級、管理者、類別名稱、作業系統清單),回傳時才算 ——
//   見 mock/hardwareRecord.js。後端沒有的(兩段式上架階段、替代機、IP 分頁、結束攤提日、弱掃明細、單號)
//   收在 `mock_only`,API 一律不吐。業務／資產類別存 id(Common 主檔序位,見 helpers/assetOptions)。
//   作業系統／應用系統存軟體 id(見 db/registry.js 的 software)。管理者在負責關係,見 db/workItems.js。

// 廠牌→型號→佔用U數 型錄(mock;正式版由後端/爬蟲提供)
export const hardwareCatalog = {
  Dell: [{ model: "PowerEdge R750", uSize: 2 }, { model: "PowerEdge R650", uSize: 1 }],
  HPE: [{ model: "ProLiant DL380", uSize: 2 }, { model: "ProLiant DL360", uSize: 1 }],
  Lenovo: [{ model: "ThinkSystem SR650", uSize: 2 }],
};

export const hardware = [
  // 韌體／作業系統、CPE、命中明細(抄 2026-09-07 testenv smoke GetById/8 的代表性四筆)都種在這一台,詳情頁才測得到有值的樣子
  {
    id: 1,
    asset_no: "SRV-A01-001",
    host_name: "核心服務主機",
    hardware_no: "SN-DELL-0001",
    is_key_business: true,
    business_category_id: 1,
    asset_category_id: 3,
    brand: "Dell",
    model: "PowerEdge R750",
    rack_id: 1,
    position_u: "U10-11",
    occupied_u: 2,
    mac_address: "00:1A:2B:3C:4D:01",
    ip_address: "10.10.32.15",
    status_name: "運作中",
    active: true,
    purchase_date: "2023-12-20T00:00:00",
    mounted_date: "2024-01-15T00:00:00",
    firmware_version: "iDRAC9 7.00.00",
    operating_system_ids: [2],
    application_system_ids: [4, 5],
    firmware_os_name: "iDRAC9",
    firmware_os_version: "iDRAC9 7.00.00.00",
    firmware_cpe: "cpe:2.3:o:dell:idrac9_firmware:7.00.00.00:*:*:*:*:*:*:*",
    eos_date: "2027-10-31T00:00:00",
    eol_date: "2026-11-30T00:00:00",
    end_of_sale_date: "2025-04-30T00:00:00",
    cve_date: "2024-04-24T00:00:00",
    cve_risk_level: "嚴重",
    cve_count: 4,
    kev_date: "2023-10-16T00:00:00",
    kev_risk_level: "高",
    kev_count: 3,
    vulnerability_hits: [
      {
        cve_id: "CVE-2023-20198",
        severity: "嚴重",
        cvss_base_score: 10,
        category: "軟體(IOS XE)",
        is_kev: true,
        kev_date_added_utc: "2023-10-16T00:00:00",
        published_on_utc: "2023-10-16T23:00:00",
        is_platform_level: true,
        description: "Cisco IOS XE Software Web Management Interface Privilege Escalation Vulnerability",
        reference_url: "https://sec.cloudapps.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-iosxe-webui-privesc-j22SaA4z",
      },
      {
        cve_id: "CVE-2017-3881",
        severity: "嚴重",
        cvss_base_score: 9.8,
        category: "軟體(IOS XE)",
        is_kev: true,
        kev_date_added_utc: "2022-03-25T00:00:00",
        published_on_utc: "2017-03-17T22:59:00.64",
        is_platform_level: true,
        description: "Cisco IOS and IOS XE Remote Code Execution Vulnerability",
        reference_url: "https://nvd.nist.gov/vuln/detail/CVE-2017-3881",
      },
      {
        cve_id: "CVE-2024-20353",
        severity: "高",
        cvss_base_score: 8.6,
        category: "軟體(IOS XE)",
        is_kev: false,
        kev_date_added_utc: null,
        published_on_utc: "2024-04-24T00:00:00",
        is_platform_level: false,
        description: "Cisco ASA and FTD Web Services Denial of Service Vulnerability",
        reference_url: "https://nvd.nist.gov/vuln/detail/CVE-2024-20353",
      },
      {
        cve_id: "CVE-2021-1234",
        severity: "無",
        cvss_base_score: null,
        category: "韌體",
        is_kev: true,
        kev_date_added_utc: "2021-11-03T00:00:00",
        published_on_utc: "2021-02-03T00:00:00",
        is_platform_level: false,
        description: "Informational advisory (no CVSS assigned)",
        reference_url: "",
      },
    ],
    mock_only: {
      parentIp: "10.10.32.1",
      subnetMask: "255.255.255.0",
      gateway: "10.10.32.254",
      dns: "168.95.1.1",
      iface: "Eth0",
      secondaryIps: ["10.10.32.115", "192.168.0.15"],
      isSpare: false,
      amortEndDate: "2028-01-15",
      docNo: "HW-2026-0001",
      approvalStatus: "approved",
      lifecycle: "commissioned",
    },
  },
  // 維修中＋替代機(mock_only);審核中(mock_only.approvalStatus=pending → is_under_review／approval_request_no)
  {
    id: 2,
    asset_no: "SRV-A01-002",
    host_name: "資料庫主機",
    hardware_no: "SN-HPE-0001",
    is_key_business: true,
    business_category_id: 1,
    asset_category_id: 2,
    brand: "HPE",
    model: "ProLiant DL380",
    rack_id: 1,
    position_u: "U12-13",
    occupied_u: 2,
    mac_address: "00:1A:2B:3C:4D:02",
    ip_address: "10.10.32.16",
    status_name: "維修中",
    active: true,
    purchase_date: "2024-02-08T00:00:00",
    mounted_date: "2024-03-01T00:00:00",
    eos_date: "2026-12-31T00:00:00",
    eol_date: "2028-03-31T00:00:00",
    end_of_sale_date: "2025-06-30T00:00:00",
    cve_risk_level: "中",
    cve_count: 1,
    kev_risk_level: "低",
    kev_count: 1,
    mock_only: {
      parentIp: "10.10.32.1",
      subnetMask: "255.255.255.0",
      gateway: "10.10.32.254",
      dns: "168.95.1.1",
      iface: "Eth0",
      secondaryIps: [],
      isSpare: false,
      spareCode: "SRV-B02-001",
      amortEndDate: "2028-02-15",
      docNo: "HW-2026-0002",
      approvalStatus: "pending",
      lifecycle: "commissioned",
    },
  },
  // 替代機本身(mock_only.isSpare)
  {
    id: 3,
    asset_no: "SRV-B02-001",
    host_name: "備援替代機",
    hardware_no: "SN-LEN-0001",
    is_key_business: false,
    business_category_id: 2,
    asset_category_id: 1,
    brand: "Lenovo",
    model: "ThinkSystem SR650",
    rack_id: 2,
    position_u: "U5",
    occupied_u: 1,
    mac_address: "00:1A:2B:3C:4D:03",
    ip_address: "10.10.33.20",
    status_name: "運作中",
    active: true,
    purchase_date: "2024-05-30T00:00:00",
    mounted_date: "2024-06-18T00:00:00",
    eos_date: "2030-06-30T00:00:00",
    eol_date: "2029-06-30T00:00:00",
    end_of_sale_date: "2027-01-31T00:00:00",
    cve_count: 0,
    kev_count: 0,
    mock_only: {
      parentIp: "",
      subnetMask: "255.255.255.0",
      gateway: "10.10.33.254",
      dns: "",
      iface: "ETH1",
      secondaryIps: [],
      isSpare: true,
      amortEndDate: "2028-03-15",
      docNo: "HW-2026-0003",
      approvalStatus: "approved",
      lifecycle: "commissioned",
    },
  },
  {
    id: 4,
    asset_no: "SRV-A01-004",
    host_name: "應用伺服器",
    hardware_no: "SN-DELL-0004",
    is_key_business: true,
    business_category_id: 1,
    asset_category_id: 3,
    brand: "Dell",
    model: "PowerEdge R650",
    rack_id: 1,
    position_u: "U14",
    occupied_u: 1,
    mac_address: "",
    ip_address: "10.10.32.18",
    status_name: "運作中",
    active: true,
    purchase_date: "2024-08-12T00:00:00",
    mounted_date: "2024-09-02T00:00:00",
    eos_date: "2028-06-30T00:00:00",
    eol_date: "2026-12-31T00:00:00",
    end_of_sale_date: "2025-04-30T00:00:00",
    cve_count: 0,
    kev_count: 0,
    mock_only: {
      parentIp: "",
      subnetMask: "255.255.255.0",
      gateway: "10.10.32.254",
      dns: "",
      iface: "",
      secondaryIps: [],
      isSpare: false,
      amortEndDate: "2028-04-15",
      docNo: "HW-2026-0004",
      approvalStatus: "approved",
      lifecycle: "commissioned",
    },
  },
  {
    id: 5,
    asset_no: "SRV-A02-001",
    host_name: "檔案伺服器",
    hardware_no: "SN-HPE-0005",
    is_key_business: true,
    business_category_id: 2,
    asset_category_id: 1,
    brand: "HPE",
    model: "ProLiant DL360",
    rack_id: 2,
    position_u: "U8",
    occupied_u: 1,
    mac_address: "00:1A:2B:3C:4D:05",
    ip_address: "10.10.33.11",
    status_name: "運作中",
    active: true,
    purchase_date: "2025-01-09T00:00:00",
    mounted_date: "2025-02-03T00:00:00",
    eos_date: "2026-11-30T00:00:00",
    eol_date: "2027-01-10T00:00:00",
    end_of_sale_date: "2025-09-30T00:00:00",
    cve_count: 0,
    kev_count: 0,
    mock_only: {
      parentIp: "10.10.33.1",
      subnetMask: "255.255.255.0",
      gateway: "10.10.33.254",
      dns: "8.8.8.8",
      iface: "Eth0",
      secondaryIps: ["10.10.33.111"],
      isSpare: false,
      amortEndDate: "2028-05-15",
      docNo: "HW-2026-0005",
      approvalStatus: "approved",
      lifecycle: "commissioned",
    },
  },
  {
    id: 6,
    asset_no: "SRV-B02-002",
    host_name: "防火牆主機",
    hardware_no: "SN-LEN-0006",
    is_key_business: false,
    business_category_id: 3,
    asset_category_id: 2,
    brand: "Lenovo",
    model: "ThinkSystem SR650",
    rack_id: 2,
    position_u: "U10",
    occupied_u: 1,
    mac_address: "",
    ip_address: "10.10.33.30",
    status_name: "維修中",
    active: true,
    purchase_date: "2025-03-25T00:00:00",
    mounted_date: "2025-04-14T00:00:00",
    eos_date: "2026-10-31T00:00:00",
    eol_date: "2028-09-30T00:00:00",
    end_of_sale_date: "2025-03-31T00:00:00",
    cve_count: 0,
    kev_count: 0,
    mock_only: {
      parentIp: "",
      subnetMask: "255.255.255.0",
      gateway: "10.10.33.254",
      dns: "",
      iface: "",
      secondaryIps: [],
      isSpare: false,
      amortEndDate: "2028-06-15",
      docNo: "HW-2026-0006",
      approvalStatus: "approved",
      lifecycle: "commissioned",
    },
  },
  // 兩段式新增的中間態(ticket 01):新增單三關通過、U 位保留,機器還沒進機房(mock_only.lifecycle=reserved)
  {
    id: 7,
    asset_no: "SRV-A01-007",
    host_name: "待上架應用主機",
    hardware_no: "SN-DELL-0007",
    is_key_business: false,
    business_category_id: 1,
    asset_category_id: 3,
    brand: "Dell",
    model: "PowerEdge R760",
    rack_id: 1,
    position_u: "U16-17",
    occupied_u: 2,
    ip_address: "",
    status_name: "運作中",
    active: true,
    purchase_date: "2026-08-20T00:00:00",
    mounted_date: "2026-09-10T00:00:00",
    eos_date: "2032-06-30T00:00:00",
    eol_date: "2031-06-30T00:00:00",
    end_of_sale_date: "2029-12-31T00:00:00",
    cve_count: 0,
    kev_count: 0,
    mock_only: {
      status: "閒置",
      isSpare: false,
      amortEndDate: "2028-07-15",
      docNo: "HW-2026-0007",
      approvalStatus: "approved",
      lifecycle: "reserved",
    },
  },
  // 2026-10-20 SIT 樣本（DcHardware/GetById/353 原樣，個資已換假）
  // SIT 掛在林口機房(room 1)的 3B01(rack 45);mock 掛到台北內湖(room 1)的 R-A02(rack 2)U17 空位 ——
  // room_id 投影出來仍是 1。廠牌／型號 id 71／1426 照 SIT,已補進 mock 的 DcBrand 主檔(mock/index.js BRANDS／MODELS)。
  // 其餘(null 的財產編號／幣別／MAC、occupied_u 0、命中一筆 CVE-2019-6159)照抄;沒有管理者(0／null),無個資。
  // cve_risk_level／cve_count／status_name 是列表列才有的鍵,抄 GetAll?riskTypes=CVE 同一筆(中／1／運作中)。
  {
    id: 8,
    business_category_id: 0,
    is_key_business: false,
    property_no: null,
    host_name: "LK-3B01-17U-elearning DB",
    asset_category_id: 0,
    asset_no: "101-002564",
    brand_id: 71,
    brand: "Lenovo",
    model_id: 1426,
    model: "System x3650 M3",
    hardware_no: "06YCC86",
    purchase_date: null,
    purchase_amount: 0,
    currency_code: null,
    mounted_date: null,
    mac_address: null,
    rack_id: 2,
    position_u: "17",
    active: true,
    created_on: "2026-09-29T10:17:19.18466+08:00",
    updated_on: "2026-10-20T18:02:16.809305+08:00",
    interface_count: 0,
    firmware_version: null,
    occupied_u: 0,
    power_count: 0,
    cpu_core_count: 0,
    ram_gb: 0,
    disk_capacity_tb: 0,
    operating_system_ids: [],
    remark: null,
    eos_date: null,
    eol_date: null,
    end_of_sale_date: null,
    latest_version: null,
    firmware_os_name: "Lenovo Integrated Management Module (IMM) / UEFI",
    firmware_os_version: null,
    cpe: "cpe:2.3:h:lenovo:system_x3650_m3:-:*:*:*:*:*:*:*",
    firmware_cpe: null,
    cve_date: "2019-08-19T15:15:11.513",
    kev_date: null,
    vulnerability_hits: [
      {
        cve_id: "CVE-2019-6159",
        severity: "中",
        cvss_base_score: 6.1,
        category: "韌體",
        is_kev: false,
        kev_date_added_utc: null,
        published_on_utc: "2019-08-19T15:15:11.513",
        is_platform_level: true,
        description: "A stored cross-site scripting (XSS) vulnerability exists in various firmware versions of the legacy IBM System x IMM (IMM v1) embedded Baseboard Management Controller (BMC). This vulnerability could allow an unauthenticated user to cause JavaScript code to be stored in the IMM log which may then be executed in the user's web browser when IMM log records containing the JavaScript code are viewed. The JavaScript code is not executed on IMM itself. The later IMM2 (IMM v2) is not affected.",
        reference_url: "https://nvd.nist.gov/vuln/detail/CVE-2019-6159",
      },
    ],
    vulnerability_scan_date: null,
    vulnerability_scan_file_url: null,
    next_vulnerability_scan_date: null,
    virtual_brand: null,
    virtual_machine_count: 0,
    virtual_cpu_core_count: 0,
    virtual_ram_gb: 0,
    virtual_disk_capacity_tb: 0,
    application_system_ids: [],
    // 列表列(DcHardwareListItemDto)才有的鍵
    ip_address: null,
    status_name: "運作中",
    cve_risk_level: "中",
    cve_count: 1,
    kev_risk_level: null,
    kev_count: 0,
    mock_only: {
      isSpare: false,
      approvalStatus: "approved",
      lifecycle: "commissioned",
    },
  },
];
